import * as serviceContext from './serviceContext';
import { deckHerosApi, realGamesApi } from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function addDeposit(data) {
    try {
        const response = await serviceContext.post("account/transaction/depositin", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function withdrawDeposit(data) {
    try {
        const response = await serviceContext.post("account/transaction/depositout", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function creditIn(data) {
    try {
        const response = await serviceContext.post("account/transaction/creditin", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function creditOut(data) {
    try {
        const response = await serviceContext.post("account/transaction/creditout", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function creditRef(data) {
    try {
        const response = await serviceContext.put("account/transaction/creditref", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function realGamesAddDeposite(data) {
    try {
        const response = await serviceContext.post(realGamesApi + "/transaction/creditin", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function realGamesWithdraw(data) {
    try {
        const response = await serviceContext.post(realGamesApi + "/transaction/creditout", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
